<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5033)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5033)" />
    </g>
    <path
      d="M11 13.3333C11 12.9797 11.1405 12.6406 11.3905 12.3905C11.6406 12.1405 11.9797 12 12.3333 12H21.6667C22.0203 12 22.3594 12.1405 22.6095 12.3905C22.8595 12.6406 23 12.9797 23 13.3333V22.6667C23 23.0203 22.8595 23.3594 22.6095 23.6095C22.3594 23.8595 22.0203 24 21.6667 24H12.3333C11.9797 24 11.6406 23.8595 11.3905 23.6095C11.1405 23.3594 11 23.0203 11 22.6667V13.3333Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M15 17.3333L17 19.3333L19 17.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <filter id="filter0_d_3254_5033"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.529299 0 0 0 0 0.274045 0 0 0 0 0.854167 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5033" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5033" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5033"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#9F69C9" />
        <stop offset="1" stop-color="#B134DD" />
      </linearGradient>
    </defs>
  </svg>
</template>
